export enum LaneType {
    CrossSection = 1,
    LogCurve = 2
}